import { ROUTE_MOCKING } from './endpoints';

class BaseUrl {
  BASE_URL = import.meta.env.VITE_API_BASE_URL;
  MOCK_ENABLED = import.meta.env.VITE_USE_MOCK_API === 'true';
  get(route) {
    //test if controller is enabled
    if (ROUTE_MOCKING[route.split('/')[1].toUpperCase()]) {
      //test if route is enabled
      if (ROUTE_MOCKING[route] && this.MOCK_ENABLED) {
        return 'http://localhost:5172'; //pointing to default vue dev server
      }
    }
    return this.BASE_URL;
  }
}

export default new BaseUrl();
